export default {
  appTitle: process.env.VUE_APP_TITLE,
  appVersion: process.env.VUE_APP_VERSION,
  baseUrl: process.env.VUE_APP_BASE_URL,
  imageUrl: process.env.VUE_APP_IMAGE_URL,
  uploadImageUrl: process.env.VUE_APP_UPLOAD_IMAGE_URL,
  viewImageUrl: process.env.VUE_APP_VIEW_IMAGE_URL,
  superUser: "admin",
  userBaseUrl: "/epicmas",
  subAccessRoles: {
    account: "account",
    ticket: "ticket",
    bank: "bank",
    promotion: "promotion",
    vip: "vip",
    report: "report",
    log: "log",
    system: "system",
    setup: "setup",
    minigame: "minigame",
    affiliate: "affiliate",
    cms: "cms"
  },
  pageParent: {
    setting: "system",
    account: "account",
    dashboard: "system",
    operator: "account",
    memberlist: "account",
    subaccount: "account",
    socialaccount: "account",
    ticket: "ticket",
    ticketlist: "ticket",
    pendingticket: "ticket",
    bank: "bank",
    bankgroup: "bank",
    bankoperator: "bank",
    bankmember: "bank",
    vip: "vip",
    promotion: "promotion",
    promogroup: "promotion",
    promopackage: "promotion",
    promoaccount: "promotion",
    promomember: "promotion",
    ibankaccount: "bank",
    membernickname: "account",
    coupon: "promotion",
    campaign: "promotion",
    setup: "setup",
    providermaintenance: "setup",
    withdrawallimit: "setup",
    providerbetlimit: "setup",
    providergameoff: "setup",
    providerrtp: "setup",
    globalsetting: "setup",
    refereelist: "report",
    minigame: "minigame",
    matchlist: "minigame",
    teamlist: "minigame",
    matchteamlog: "minigame",
    matchresultlog: "minigame",
    bankstatement: "report",
    bankstatementdaily: "report",
    onetimedepositor: "report",
    currentmonthnondepositor: "report",
    currentmonthnologin: "report",
    promotionsummary: "report",
    adjustmemberlog: "log",
    issuebonuslog: "log",
    dailystatement: "report",
    dailywinlose: "report",
    gameresultchangeslog: "log",
    platformwinlose: "report",
    dailysummarycompany: "report",
    dailysummarymember: "report",
    gameresultslots: "report",
    gameresultlivecasino: "report",
    gameresultrebate: "report",
    gameresultsportsbook: "report",
    bonuslist: "report",
    adjustmentlist: "report",
    promotionsignupunusedlist: "report",
    promotionsignupongoing: "report",
    promosignup: "promotion",
    depositedmember: "report",
    registeredmember: "report",
    firstdeposit: "report",
    memberexport: "export_excel",
    providerwinlosecompany: "providerwinlose",
    affiliate: "affiliate",
    approveaffiliate: "affiliate",
    affiliatelist: "affiliate",
    bankaffiliate: "affiliate",
    ticketaffiliate: "affiliate",
    settlementlistaffiliate: "affiliate",
    dailywinloseaffiliate: "affiliate",
    dailywinlosememberaffiliate: "affiliate",
    commupdatelogaffiliate: "affiliate",
    playerlist: "affiliate",
    reviewlist: "account",
    monthlyrating: "account",
    surveylist: "account",
    utmlist: "report",
    minigameprizereport: "report",
    depositedmembercny: "report",
    membermission: "promotion",
    ticketexport: "report",
    memberdetails: "account",
    promotionwithdrawalsummary: "report",
    freespinlog: "log",
    exchangerate: "setup",
    logrepulling: "setup",
    membermissionsummary: "promotion",
    cms: "cms",
    announcementbanner: "cms",
    promotionbanner: "cms",
    slidebanner: "cms",
    seopage: "cms",
    news: "cms",
  },
  accessRoles: {
    account: "account",
    dashboard: "dashboard",
    operator: "operator",
    memberlist: "memberlist",
    subaccount: "subaccount",
    ticket: "ticket",
    ticketlist: "ticketlist",
    pendingticket: "pendingticket",
    bank: "bank",
    bankgroup: "bankgroup",
    bankoperator: "bankoperator",
    bankmember: "bankmember",
    security: "security",
    setting: "setting",
    report: "report",
    vip: "vip",
    promotion: "promotion",
    promogroup: "promogroup",
    promopackage: "promopackage",
    promoaccount: "promoaccount",
    promomember: "promomember",
    ibankaccount: "ibankaccount",
    socialaccount: "socialaccount",
    membernickname: "membernickname",
    coupon: "coupon",
    campaign: "campaign",
    setup: "setup",
    providermaintenance: "providermaintenance",
    withdrawallimit: "withdrawallimit",
    providerbetlimit: "providerbetlimit",
    providergameoff: "providergameoff",
    providerrtp: "providerrtp",
    globalsetting: "globalsetting",
    refereelist: "refereelist",
    minigame: "minigame",
    matchlist: "matchlist",
    teamlist: "teamlist",
    matchteamlog: "matchteamlog",
    matchresultlog: "matchresultlog",
    bankstatement: "bankstatement",
    bankstatementdaily: "bankstatementdaily",
    onetimedepositor: "onetimedepositor",
    currentmonthnondepositor: "currentmonthnondepositor",
    currentmonthnologin: "currentmonthnologin",
    promotionsummary: "promotionsummary",
    adjustmemberlog: "adjustmemberlog",
    issuebonuslog: "issuebonuslog",
    dailystatement: "dailystatement",
    dailywinlose: "dailywinlose",
    gameresultchangeslog: "gameresultchangeslog",
    platformwinlose: "platformwinlose",
    dailysummarycompany: "dailysummarycompany",
    gameresultslots: "gameresultslots",
    gameresultlivecasino: "gameresultlivecasino",
    gameresultrebate: "gameresultrebate",
    gameresultsportsbook: "gameresultsportsbook",
    bonuslist: "bonuslist",
    adjustmentlist: "adjustmentlist",
    promotionsignupunusedlist: "promotionsignupunusedlist",
    promotionsignupongoing: "promotionsignupongoing",
    promosignup: "promosignup",
    depositedmember: "depositedmember",
    registeredmember: "registeredmember",
    firstdeposit: "firstdeposit",
    memberexport: "memberexport",
    providerwinlosecompany: "providerwinlosecompany",
    affiliate: "affiliate",
    approveaffiliate: "affiliate",
    affiliatelist: "affiliate",
    bankaffiliate: "affiliate",
    ticketaffiliate: "affiliate",
    settlementlistaffiliate: "affiliate",
    dailywinloseaffiliate: "affiliate",
    dailywinlosememberaffiliate: "affiliate",
    commupdatelogaffiliate: "affiliate",
    playerlist: "affiliate",
    reviewlist: "reviewlist",
    monthlyrating: "monthlyrating",
    surveylist: "surveylist",
    utmlist: "utmlist",
    minigameprizereport: "minigameprizereport",
    depositedmembercny: "depositedmembercny",
    membermission: "membermission",
    ticketexport: "ticketexport",
    memberdetails: "memberdetails",
    promotionwithdrawalsummary: "promotionwithdrawalsummary",
    freespinlog: "freespinlog",
    exchangerate: "exchangerate",
    logrepulling: "logrepulling",
    membermissionsummary: "membermissionsummary",
    cms: "cms",
    announcementbanner: "cms",
    promotionbanner: "cms",
    slidebanner: "cms",
    seopage: "cms",
    news: "cms",
  },
  accessUrlPrefix: {
    operator: "/account",
    memberlist: "/account",
    subaccount: "/account",
    ticket: "/ticket",
    ticketlist: "/ticket",
    pendingticket: "/ticket",
    bankgroup: "/bank",
    bankoperator: "/bank",
    bankmember: "/bank",
    setting: "/system",
    report: "/report",
    vip: "/vip",
    minigame: "/minigame",
    promopackage: "/promotion",
    promogroup: "/promotion",
    promoaccount: "/promotion",
    promomember: "/promotion",
    ibankaccount: "/ibank",
    socialaccount: "/account",
    membernickname: "/account",
    coupon: "/promotion",
    campaign: "/promotion",
    providermaintenance: "/setup",
    withdrawallimit: "/setup",
    providerbetlimit: "/setup",
    providergameoff: "/setup",
    providerrtp: "/setup",
    globalsetting: "/setup",
    refereelist: "/report",
    teamlist: "/minigame",
    matchlist: "/minigame",
    matchteamlog: "/minigame",
    matchresultlog: "/minigame",
    bankstatement: "/report",
    bankstatementdaily: "/report",
    onetimedepositor: "/report",
    currentmonthnondepositor: "/report",
    currentmonthnologin: "/report",
    promotionsummary: "/report",
    adjustmemberlog: "/log",
    issuebonuslog: "/log",
    dailystatement: "/report",
    dailywinlose: "/report",
    gameresultchangeslog: "/log",
    platformwinlose: "/report",
    dailysummarycompany: "/report",
    gameresultslots: "/report",
    gameresultlivecasino: "/report",
    gameresultrebate: "/report",
    gameresultsportsbook: "/report",
    bonuslist: "/report",
    adjustmentlist: "/report",
    promotionsignupunusedlist: "/report",
    promotionsignupongoing: "/report",
    promosignup: "/promotion",
    depositedmember: "/report",
    registeredmember: "/report",
    firstdeposit: "/report",
    providerwinlosecompany: "/report",
    memberexport: "/report",
    approveaffiliate: "/affiliate",
    affiliatelist: "/affiliate",
    bankaffiliate: "/affiliate",
    ticketaffiliate: "/affiliate",
    settlementlistaffiliate: "/affiliate",
    dailywinloseaffiliate: "/affiliate",
    dailywinlosememberaffiliate: "/affiliate",
    commupdatelogaffiliate: "/affiliate",
    playerlist: "/affiliate",
    reviewlist: "/review",
    monthlyrating: "/review",
    surveylist: "/review",
    utmlist: "/report",
    minigameprizereport: "/report",
    depositedmembercny: "/report",
    membermission: "/promotion",
    ticketexport: "/report",
    memberdetails: "/account",
    promotionwithdrawalsummary: "/report",
    freespinlog: "/log",
    exchangerate: "/setup",
    logrepulling: "/setup",
    membermissionsummary: "/promotion",
    announcementbanner: "/cms",
    promotionbanner: "/cms",
    slidebanner: "/cms",
    seopage: "/cms",
    news: "/cms",
  },
  affSubAccPasswords: "admin123!@#",
  bankingList: [{ text: 'IBANK', value: 'IBANK'}, { text: 'MANUAL', value: 'MANUAL'}],
  // gameResultDetailUrl: "https://result.apiepiccash.com/result?bet_id=",
  resultDetailProvider: [
    "EPIC", "HBNR", "LIVE22", "SPADE", "PP-S", "PGS", "JK", "MEGAH5", "CQ9", "JILI", "EPIC2",
    "SPNX", "EVONTT", "HSD", "BNG", "SPB", "EVOBTG", "RG", "JDB", "YBNGO", "EVOP", "ALG", "QM",
    "JDB-GTF", "FC", "EVONLC", "BG", "AP", "PNG", "MG1", "EVOLIVE", "WIFY", "YB"
  ],
  resultDetail: {
    "epicUrl": process.env.VUE_APP_BET_DETAIL_URL_EPIC + "/result?bet_id=",
    "habaneroUrl": process.env.VUE_APP_BET_DETAIL_URL_HBNR + "/getbetdetail",
    "live22Url": process.env.VUE_APP_BET_DETAIL_URL_LIVE22 + "/getbetdetail",
    "spadeUrl": process.env.VUE_APP_BET_DETAIL_URL_SPADE + "/getbetdetail",
    "pragmaticUrl": process.env.VUE_APP_BET_DETAIL_URL_PPS + "/getbetdetail",
    "pgsoftUrl": process.env.VUE_APP_BET_DETAIL_URL_PGS + "/getbetdetail",
    "jokerUrl": process.env.VUE_APP_BET_DETAIL_URL_JK + "/getbetdetail",
    "megah5Url": process.env.VUE_APP_BET_DETAIL_URL_MEGAH5 + "/getbetdetail",
    "cq9Url": process.env.VUE_APP_BET_DETAIL_URL_CQ9 + "/getbetdetail",
    "jiliUrl": process.env.VUE_APP_BET_DETAIL_URL_JILI + "/getbetdetail",
    "epic2Url": process.env.VUE_APP_BET_DETAIL_URL_EPIC2 + "/getbetdetail",
    "oneUrl": process.env.VUE_APP_BET_DETAIL_URL_ONE + "/getbetdetail",
  },
  getGameList: {
    "epicUrl": process.env.VUE_APP_GAME_LIST_URL_EPIC + "/osg/getGameList?lang=en",
    "habaneroUrl": process.env.VUE_APP_GAME_LIST_URL_HBNR + "/getgamelist",
    "live22Url": process.env.VUE_APP_GAME_LIST_URL_LIVE22 + "/getgamelist?lang=en",
    "spadeUrl": process.env.VUE_APP_GAME_LIST_URL_SPADE + "/getgamelist",
    "pragmaticUrl": process.env.VUE_APP_GAME_LIST_URL_PPS + "/getgamelist",
    "jokerUrl": process.env.VUE_APP_GAME_LIST_URL_JK + "/getgamelist",
    "megah5Url": process.env.VUE_APP_GAME_LIST_URL_MEGAH5 + "/getgamelist?lang=en",
    "cq9Url": process.env.VUE_APP_GAME_LIST_URL_CQ9 + "/getgamelist",
    "jiliUrl": process.env.VUE_APP_GAME_LIST_URL_JILI + "/getgamelist",
    "epic2Url": process.env.VUE_APP_GAME_LIST_URL_EPIC2 + "/getgamelist?lang=en",
    "oneUrl": process.env.VUE_APP_GAME_LIST_URL_ONE + "/getgamelist",
  },
  logRepulling: {
    "oneUrl": process.env.VUE_APP_LOG_REPULL_URL_ONE + "/FilteredReport",
  },
  gameIdField: {
    "EPIC": "GameCode",
    "HBNR": "KeyName",
    "LIVE22": "GameId",
    "SPADE": "gameCode",
    "PP-S": "gameID",
    "JK": "GameCode",
    "MEGAH5": "GameCode",
    "CQ9": "gamecode",
    "JILI": "GameId",
    "EPIC2": "GameCode",
    "SPNX": "game_code",
    "EVONTT": "game_code",
    "HSD": "game_code",
    "BNG": "game_code",
    "SPB": "game_code",
    "EVOBTG": "game_code",
    "RG": "game_code",
    "JDB": "game_code",
    "YBNGO": "game_code",
    "EVOP": "game_code",
    "ALG": "game_code",
    "QM": "game_code",
    "JDB-GTF": "game_code",
    "FC": "game_code",
    "EVONLC": "game_code",
    "BG": "game_code",
    "AP": "game_code",
    "PNG": "game_code",
    "MG1": "game_code"
  },
  gameNameField: {
    "EPIC": "GameName",
    "HBNR": "Name",
    "LIVE22": "GameName",
    "SPADE": "gameName",
    "PP-S": "gameName",
    "JK": "GameName",
    "MEGAH5": "GameName",
    "CQ9": "gamename",
    "JILI": "name",
    "EPIC2": "GameName",
    "SPNX": "game_name",
    "EVONTT": "game_name",
    "HSD": "game_name",
    "BNG": "game_name",
    "SPB": "game_name",
    "EVOBTG": "game_name",
    "RG": "game_name",
    "JDB": "game_name",
    "YBNGO": "game_name",
    "EVOP": "game_name",
    "ALG": "game_name",
    "QM": "game_name",
    "JDB-GTF": "game_name",
    "FC": "game_name",
    "EVONLC": "game_name",
    "BG": "game_name",
    "AP": "game_name",
    "PNG": "game_name",
    "MG1": "game_name"
  },
  adminAccessOptions: [
    'account', 'ticket', 'bank', 'promotion', 'vip', 'setup', 'providerwinlose', 'affiliate', 'export_excel'
  ],
  operatorAccessOptions: [
    'account', 'ticket', 'bank', 'promotion', 'vip', 'setup', 'providerwinlose', 'export_excel'
  ],
  adminPages: [
    'operator', 'matchlist', 'teamlist', 'affiliate'
  ],
  intMaxValue: 2000000000,
  pgUserCodePrefix: "EPICPG_",
  accountAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountadd";
  },
  accountDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountdetail";
  },
  accountEditUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountedit";
  },
  accountListUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountlist";
  },
  accountLoginUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountlogin";
  },
  accountProfileUnblockUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountprofileunblock";
  },
  accountSocialGetUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsocialget";
  },
  accountSocialUpsertUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsocialupsert";
  },
  accountStatusUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountstatusupdate";
  },
  accountSubAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsubadd";
  },
  accountSubBlockUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsubblock";
  },
  accountSubDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsubdetail";
  },
  accountSubEditUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsubedit";
  },
  accountSubListUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsublist";
  },
  accountSubUnblockUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsubunblock";
  },
  passwordResetUrl() {
    return this.baseUrl + this.userBaseUrl + "/passwordreset";
  },
  passwordResetMemberUrl() {
    return this.baseUrl + this.userBaseUrl + "/passwordresetmember";
  },
  passwordResetSubUrl() {
    return this.baseUrl + this.userBaseUrl + "/passwordresetsub";
  },
  passwordUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/passwordupdate";
  },
  refereeListUrl() {
    return this.baseUrl + this.userBaseUrl + "/refereelist";
  },
  securityUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/securityupdate";
  },
  securityValidateUrl() {
    return this.baseUrl + this.userBaseUrl + "/securityvalidate";
  },
  bankAccountGroupAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankaccountgroupadd";
  },
  bankAccountGroupListUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankaccountgrouplist";
  },
  bankAccountGroupRemoveUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankaccountgroupremove";
  },
  bankAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankadd";
  },
  bankEditUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankedit";
  },
  bankGroupAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankgroupadd";
  },
  bankGroupDefaultUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankgroupdefault";
  },
  bankGroupEditUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankgroupedit";
  },
  bankGroupListUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankgrouplist";
  },
  bankListUrl() {
    return this.baseUrl + this.userBaseUrl + "/banklist";
  },
  bankListWithdrawalUrl() {
    return this.baseUrl + this.userBaseUrl + "/banklistwithdrawal";
  },
  bankLookupUrl() {
    return this.baseUrl + this.userBaseUrl + "/banklookup";
  },
  bankMemberListUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankmemberlist";
  },
  bankMemberStatusUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankmemberstatusupdate";
  },
  bankMemberUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankmemberupdate";
  },
  bankResetUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankreset";
  },
  bankSettingListUrl() {
    return this.baseUrl + this.userBaseUrl + "/banksettinglist";
  },
  bankSettingUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/banksettingupdate";
  },
  bankStatusUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankstatusupdate";
  },
  iBankListUrl() {
    return this.baseUrl + this.userBaseUrl + "/ibanklist";
  },
  ibankStatusUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/ibankstatusupdate";
  },
  campaignAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/campaignadd";
  },
  campaignEditUrl() {
    return this.baseUrl + this.userBaseUrl + "/campaignedit";
  },
  campaignListUrl() {
    return this.baseUrl + this.userBaseUrl + "/campaignlist";
  },
  couponAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/couponadd";
  },
  couponGetUrl() {
    return this.baseUrl + this.userBaseUrl + "/couponget";
  },
  couponListUrl() {
    return this.baseUrl + this.userBaseUrl + "/couponlist";
  },
  couponUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/couponupdate";
  },
  globalSettingListUrl() {
    return this.baseUrl + this.userBaseUrl + "/globalsettinglist";
  },
  globalSettingUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/globalsettingupdate";
  },
  providerMaintenanceListUrl() {
    return this.baseUrl + this.userBaseUrl + "/providermaintenancelist";
  },
  providerMaintenanceUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/providermaintenanceupdate";
  },
  memberEditUrl() {
    return this.baseUrl + this.userBaseUrl + "/memberedit";
  },
  memberListUrl() {
    return this.baseUrl + this.userBaseUrl + "/memberlist";
  },
  memberProfileBankGroupUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/memberprofilebankgroupupdate";
  },
  memberProfilePromotionGroupUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/memberprofilepromotiongroupupdate";
  },
  memberProfileWithdrawalLimitUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/memberprofilewithdrawallimitupdate";
  },
  memberStatusUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/memberstatusupdate";
  },
  memberStatusUpdateReferralUrl() {
    return this.baseUrl + this.userBaseUrl + "/memberstatusupdatereferral";
  },
  memberTacBankGetUrl() {
    return this.baseUrl + this.userBaseUrl + "/membertacbankget";
  },
  memberTacGetUrl() {
    return this.baseUrl + this.userBaseUrl + "/membertacget";
  },
  memberUnblockUrl() {
    return this.baseUrl + this.userBaseUrl + "/memberunblock";
  },
  memberWalletAdjustUrl() {
    return this.baseUrl + this.userBaseUrl + "/memberwalletadjust";
  },
  promotionAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionadd";
  },
  promotionClaimTypeLookupUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionclaimtypelookup";
  },
  promotionGroupAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotiongroupadd";
  },
  promotionGroupDefaultUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotiongroupdefault";
  },
  promotionGroupEditUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotiongroupedit";
  },
  promotionGroupListUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotiongrouplist";
  },
  promotionGroupNormAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotiongroupnormadd";
  },
  promotionGroupNormListUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotiongroupnormlist";
  },
  promotionGroupNormRemoveUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotiongroupnormremove";
  },
  promotionListUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionlist";
  },
  promotionMemberKnockOffUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionmemberknockoff";
  },
  promotionMemberListUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionmemberlist";
  },
  promotionSignupEditUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionsignupedit";
  },
  promotionSignupGetUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionsignupget";
  },
  promotionSignupStatusUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionsignupstatusupdate";
  },
  promotionStatusUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionstatusupdate";
  },
  ticketApproveDepositUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketapprovedeposit";
  },
  ticketApproveWithdrawalUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketapprovewithdrawal";
  },
  ticketDepositApproveUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketdepositapprove";
  },
  ticketDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketdetail";
  },
  ticketListUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketlist";
  },
  ticketListPendingUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketlistpending";
  },
  ticketRedepositApproveUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketredepositapprove";
  },
  ticketRejectDepositUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketrejectdeposit";
  },
  ticketRejectWithdrawalUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketrejectwithdrawal";
  },
  withdrawalLimitAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/withdrawallimitadd";
  },
  withdrawalLimitDefaultUrl() {
    return this.baseUrl + this.userBaseUrl + "/withdrawallimitdefault";
  },
  withdrawalLimitEditUrl() {
    return this.baseUrl + this.userBaseUrl + "/withdrawallimitedit";
  },
  withdrawalLimitListUrl() {
    return this.baseUrl + this.userBaseUrl + "/withdrawallimitlist";
  },
  vipLookupUrl() {
    return this.baseUrl + this.userBaseUrl + "/viplookup";
  },
  vipProviderEditUrl() {
    return this.baseUrl + this.userBaseUrl + "/vipprovideredit";
  },
  vipProviderListUrl() {
    return this.baseUrl + this.userBaseUrl + "/vipproviderlist";
  },
  betListUrl() {
    return this.baseUrl + this.userBaseUrl + "/betlist";
  },
  logMatchResultUrl() {
    return this.baseUrl + this.userBaseUrl + "/logmatchresult";
  },
  logMatchTeamUrl() {
    return this.baseUrl + this.userBaseUrl + "/logmatchteam";
  },
  matchListUrl() {
    return this.baseUrl + this.userBaseUrl + "/matchlist";
  },
  resultInsertUrl() {
    return this.baseUrl + this.userBaseUrl + "/resultinsert";
  },
  resultListUrl() {
    return this.baseUrl + this.userBaseUrl + "/resultlist";
  },
  resultUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/resultupdate";
  },
  teamListUrl() {
    return this.baseUrl + this.userBaseUrl + "/teamlist";
  },
  teamLookupUrl() {
    return this.baseUrl + this.userBaseUrl + "/teamlookup";
  },
  teamUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/teamupdate";
  },
  bankStatementUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankstatement";
  },
  bankStatementDailyUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankstatementdaily";
  },
  currentMonthNonDepositorUrl() {
    return this.baseUrl + this.userBaseUrl + "/currentmonthnondepositor";
  },
  currentMonthNoLoginUrl() {
    return this.baseUrl + this.userBaseUrl + "/currentmonthnologin";
  },
  oneTimeDepositorUrl() {
    return this.baseUrl + this.userBaseUrl + "/onetimedepositor";
  },
  bankAdjustUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankadjust";
  },
  bankTransferUrl() {
    return this.baseUrl + this.userBaseUrl + "/banktransfer";
  },
  dailyStatementUrl() {
    return this.baseUrl + this.userBaseUrl + "/dailystatement";
  },
  platformWinLoseUrl() {
    return this.baseUrl + this.userBaseUrl + "/platformwinlose";
  },
  gameResultSlotsUrl() {
    return this.baseUrl + this.userBaseUrl + "/gameresultslots";
  },
  gameResultLivecasinoUrl() {
    return this.baseUrl + this.userBaseUrl + "/gameresultlivecasino";
  },
  gameResultLivecasinoDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/gameresultlivecasinodetail";
  },
  gameResultRebateUrl() {
    return this.baseUrl + this.userBaseUrl + "/gameresultrebate";
  },
  gameResultSportsbookUrl() {
    return this.baseUrl + this.userBaseUrl + "/gameresultsportsbook";
  },
  promotionSummaryUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionsummary";
  },
  promotionSummaryDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionsummarydetail";
  },
  bonusIssueUrl() {
    return this.baseUrl + this.userBaseUrl + "/bonusissue";
  },
  bonusIssuePromoUrl() {
    return this.baseUrl + this.userBaseUrl + "/bonusissuepromo";
  },
  promotionMemberAssignUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionmemberassign";
  },
  memberVipGetUrl() {
    return this.baseUrl + this.userBaseUrl + "/membervipget";
  },
  memberVipUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/membervipupdate";
  },
  memberDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/memberdetail";
  },
  memberProfileGetUrl() {
    return this.baseUrl + this.userBaseUrl + "/memberprofileget";
  },
  memberProfilePromotionGroupUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/memberprofilepromotiongroupupdate";
  },
  memberProfileWithdrawalLimitUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/memberprofilewithdrawallimitupdate";
  },
  memberProfileBankGroupUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/memberprofilebankgroupupdate";
  },
  betLimitProviderListUrl() {
    return this.baseUrl + this.userBaseUrl + "/betlimitproviderlist";
  },
  betLimitProviderUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/betlimitproviderupdate";
  },
  betLimitMemberListUrl() {
    return this.baseUrl + this.userBaseUrl + "/betlimitmemberlist";
  },
  betLimitMemberUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/betlimitmemberupdate";
  },
  bankListDepositUrl() {
    return this.baseUrl + this.userBaseUrl + "/banklistdeposit";
  },
  promotionLookupUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionlookup";
  },
  adjustmentListUrl() {
    return this.baseUrl + this.userBaseUrl + "/adjustmentlist";
  },
  bonusListUrl() {
    return this.baseUrl + this.userBaseUrl + "/bonuslist";
  },
  dailySummaryCompanyUrl() {
    return this.baseUrl + this.userBaseUrl + "/dailysummarycompany";
  },
  dailySummaryMemberUrl() {
    return this.baseUrl + this.userBaseUrl + "/dailysummarymember";
  },
  promotionSignupUnusedListUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionsignupunusedlist";
  },
  promotionSignupOngoingUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionsignupongoing";
  },
  inboxListUrl() {
    return this.baseUrl + this.userBaseUrl + "/inboxlist";
  },
  gameResultChangesUrl() {
    return this.baseUrl + this.userBaseUrl + "/gameresultchanges";
  },
  dashboardUrl() {
    return this.baseUrl + this.userBaseUrl + "/dashboard";
  },
  ticketListPendingCountUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketlistpendingcount";
  },
  memberSummaryUrl() {
    return this.baseUrl + this.userBaseUrl + "/membersummary";
  },
  providerGameOffAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/providergameoffadd";
  },
  providerGameOffListUrl() {
    return this.baseUrl + this.userBaseUrl + "/providergameofflist";
  },
  providerGameOffRemoveUrl() {
    return this.baseUrl + this.userBaseUrl + "/providergameoffremove";
  },
  providerRtpListUrl() {
    return this.baseUrl + this.userBaseUrl + "/providerrtplist";
  },
  providerRtpEditUrl() {
    return this.baseUrl + this.userBaseUrl + "/providerrtpedit";
  },
  depositedMemberUrl() {
    return this.baseUrl + this.userBaseUrl + "/depositedmember";
  },
  registeredMemberUrl() {
    return this.baseUrl + this.userBaseUrl + "/registeredmember";
  },
  rebateGetUrl() {
    return this.baseUrl + this.userBaseUrl + "/rebateget";
  },
  checkMemberFreeSpinUrl() {
    return this.baseUrl + this.userBaseUrl + "/checkmemberfreespin";
  },
  firstDepositUrl() {
    return this.baseUrl + this.userBaseUrl + "/firstdeposit";
  },
  promotionSignupAssignUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionsignupassign";
  },
  providerWinLoseCompanyUrl() {
    return this.baseUrl + this.userBaseUrl + "/providerwinlosecompany";
  },
  accountDetailAffiliateUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountdetailaffiliate";
  },
  accountListAffiliateUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountlistaffiliate";
  },
  accountStatusUpdateAffiliateUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountstatusupdateaffiliate";
  },
  accountUnblockAffiliateUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountunblockaffiliate";
  },
  accountUpdateAffiliateUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountupdateaffiliate";
  },
  affiliateApproveUrl() {
    return this.baseUrl + this.userBaseUrl + "/affiliateapprove";
  },
  passwordResetAffiliateUrl() {
    return this.baseUrl + this.userBaseUrl + "/passwordresetaffiliate";
  },
  bankAccountListAffiliateUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankaccountlistaffiliate";
  },
  bankAccountUpdateAffiliateUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankaccountupdateaffiliate";
  },
  ticketApproveaffiliateUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketapproveaffiliate";
  },
  ticketListAffiliateUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketlistaffiliate";
  },
  ticketRejectAffiliateUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketrejectaffiliate";
  },
  walletAdjustAffiliateUrl() {
    return this.baseUrl + this.userBaseUrl + "/walletadjustaffiliate";
  },
  commPackageLookupUrl() {
    return this.baseUrl + this.userBaseUrl + "/commpackagelookup";
  },
  accountCommUpdateAffiliateUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountcommupdateaffiliate";
  },
  bankAccountWithdrawalListUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankaccountwithdrawallist";
  },
  accountSubDetailAffiliateUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsubdetailaffiliate";
  },
  settlementListAffiliateUrl() {
    return this.baseUrl + this.userBaseUrl + "/settlementlistaffiliate";
  },
  commUpdateLogAffiliateUrl() {
    return this.baseUrl + this.userBaseUrl + "/commupdatelogaffiliate";
  },
  dailyWinLoseAffUrl() {
    return this.baseUrl + this.userBaseUrl + "/dailywinloseaff";
  },
  dailyWinLoseAffiliateAffUrl() {
    return this.baseUrl + this.userBaseUrl + "/dailywinloseaffiliateaff";
  },
  dailyWinLoseAffiliateMemberAffUrl() {
    return this.baseUrl + this.userBaseUrl + "/dailywinloseaffiliatememberaff";
  },
  dailyWinLoseMemberAffiliateUrl() {
    return this.baseUrl + this.userBaseUrl + "/dailywinlosememberaffiliate";
  },
  tacGetUrl() {
    return this.baseUrl + this.userBaseUrl + "/tacget";
  },
  accountMemberListAffiliateUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountmemberlistaffiliate";
  },
  accountMemberListMasterAffiliateUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountmemberlistmasteraffiliate";
  },
  auditLoginMemberUrl() {
    return this.baseUrl + this.userBaseUrl + "/auditloginmember";
  },
  auditFreebiesListUrl() {
    return this.baseUrl + this.userBaseUrl + "/auditfreebieslist";
  },
  auditFreebiesAckUrl() {
    return this.baseUrl + this.userBaseUrl + "/auditfreebiesack";
  },
  reviewListUrl() {
    return this.baseUrl + this.userBaseUrl + "/reviewlist";
  },
  reviewDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/reviewdetail";
  },
  reviewReplyUrl() {
    return this.baseUrl + this.userBaseUrl + "/reviewreply";
  },
  monthlyRatingUrl() {
    return this.baseUrl + this.userBaseUrl + "/monthlyrating";
  },
  recentDepositUrl() {
    return this.baseUrl + this.userBaseUrl + "/recentdeposit";
  },
  monthlyRatingUrl() {
    return this.baseUrl + this.userBaseUrl + "/monthlyrating";
  },
  surveyAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/surveyadd";
  },
  surveyLookupUrl() {
    return this.baseUrl + this.userBaseUrl + "/surveylookup";
  },
  surveyStatusUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/surveystatusupdate";
  },
  clearOutstandingUrl() {
    return this.baseUrl + this.userBaseUrl + "/clearoutstanding";
  },
  memberWalletGetUrl() {
    return this.baseUrl + this.userBaseUrl + "/memberwalletget";
  },
  traceOutstandingUrl() {
    return this.baseUrl + this.userBaseUrl + "/traceoutstanding";
  },
  dailyWinLoseUrl() {
    return this.baseUrl + this.userBaseUrl + "/dailywinlose";
  },
  providerMaintenanceClearUrl() {
    return this.baseUrl + this.userBaseUrl + "/providermaintenanceclear";
  },
  promotionGroupNormUpdateSeqUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotiongroupnormupdateseq";
  },
  utmListUrl() {
    return this.baseUrl + this.userBaseUrl + "/utmlist";
  },
  campaignUpdateProviderUrl() {
    return this.baseUrl + this.userBaseUrl + "/campaignupdateprovider";
  },
  miniGamePrizeGetUrl() {
    return this.baseUrl + this.userBaseUrl + "/minigameprizeget";
  },
  miniGameTokenGetUrl() {
    return this.baseUrl + this.userBaseUrl + "/minigametokenget";
  },
  miniGameTokenIssueUrl() {
    return this.baseUrl + this.userBaseUrl + "/minigametokenissue";
  },
  miniGamePrizeSummaryUrl() {
    return this.baseUrl + this.userBaseUrl + "/minigameprizesummary";
  },
  miniGamePrizeDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/minigameprizedetail";
  },
  memberDepositCNY2024Url() {
    return this.baseUrl + this.userBaseUrl + "/memberdepositcny2024";
  },
  memberMissionListUrl() {
    return this.baseUrl + this.userBaseUrl + "/membermissionlist";
  },
  memberMissionDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/membermissiondetail";
  },
  epic2GetUnfinishRoundUrl() {
    return this.baseUrl + this.userBaseUrl + "/epic2getunfinishround";
  },
  epic2CancelUnfinishRoundUrl() {
    return this.baseUrl + this.userBaseUrl + "/epic2cancelunfinishround";
  },
  epic2CreateFreeRoundUrl() {
    return this.baseUrl + this.userBaseUrl + "/epic2createfreeround";
  },
  epic2GetFreeRoundUrl() {
    return this.baseUrl + this.userBaseUrl + "/epic2getfreeround";
  },
  epic2GetFreeRoundGameListUrl() {
    return this.baseUrl + this.userBaseUrl + "/epic2getfreeroundgamelist";
  },
  megah5GetUnfinishRoundUrl() {
    return this.baseUrl + this.userBaseUrl + "/megah5getunfinishround";
  },
  megah5CancelUnfinishRoundUrl() {
    return this.baseUrl + this.userBaseUrl + "/megah5cancelunfinishround";
  },
  megah5CreateFreeRoundUrl() {
    return this.baseUrl + this.userBaseUrl + "/megah5createfreeround";
  },
  megah5GetFreeRoundUrl() {
    return this.baseUrl + this.userBaseUrl + "/megah5getfreeround";
  },
  megah5GetFreeRoundGameListUrl() {
    return this.baseUrl + this.userBaseUrl + "/megah5getfreeroundgamelist";
  },
  memberSummaryV2Url() {
    return this.baseUrl + this.userBaseUrl + "/membersummaryv2";
  },
  promotionWithdrawalSummaryUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionwithdrawalsummary";
  },
  promotionWithdrawalSummaryDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionwithdrawalsummarydetail";
  },
  freespinLogListUrl() {
    return this.baseUrl + this.userBaseUrl + "/freespinloglist";
  },
  exchangeRateListUrl() {
    return this.baseUrl + this.userBaseUrl + "/exchangeratelist";
  },
  exchangeRateUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/exchangerateupdate";
  },
  memberMissionSummaryUrl() {
    return this.baseUrl + this.userBaseUrl + "/membermissionsummary";
  },
  
  cmsAnnouncementBannerAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsannouncementbanneradd";
  },
  cmsAnnouncementBannerCountUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsannouncementbannercount";
  },
  cmsAnnouncementBannerDeleteUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsannouncementbannerdelete";
  },
  cmsAnnouncementBannerDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsannouncementbannerdetail";
  },
  cmsAnnouncementBannerEditUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsannouncementbanneredit";
  },
  cmsAnnouncementBannerListUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsannouncementbannerlist";
  },
  cmsAnnouncementBannerMoveUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsannouncementbannermove";
  },
  cmsAnnouncementBannerStatusUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsannouncementbannerstatusupdate";
  },
  cmsAnnouncementBannerUpDownUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsannouncementbannerupdown";
  },

  cmsPromotionBannerAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmspromotionbanneradd";
  },
  cmsPromotionBannerCountUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmspromotionbannercount";
  },
  cmsPromotionBannerDeleteUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmspromotionbannerdelete";
  },
  cmsPromotionBannerDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmspromotionbannerdetail";
  },
  cmsPromotionBannerEditUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmspromotionbanneredit";
  },
  cmsPromotionBannerListUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmspromotionbannerlist";
  },
  cmsPromotionBannerMoveUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmspromotionbannermove";
  },
  cmsPromotionBannerStatusUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmspromotionbannerstatusupdate";
  },
  cmsPromotionBannerUpDownUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmspromotionbannerupdown";
  },
  cmsPromotionBannerLookupUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmspromotionbannerlookup";
  },
  promotionCategoryLookupUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotioncategorylookup";
  },

  cmsSEOPageAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsseopageadd";
  },
  cmsSEOPageDeleteUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsseopagedelete";
  },
  cmsSEOPageDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsseopagedetail";
  },
  cmsSEOPageEditUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsseopageedit";
  },
  cmsSEOPageListUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsseopagelist";
  },
  cmsSEOPageStatusUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsseopagestatusupdate";
  },

  cmsSlideBannerAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsslidebanneradd";
  },
  cmsSlideBannerCountUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsslidebannercount";
  },
  cmsSlideBannerDeleteUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsslidebannerdelete";
  },
  cmsSlideBannerDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsslidebannerdetail";
  },
  cmsSlideBannerEditUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsslidebanneredit";
  },
  cmsSlideBannerListUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsslidebannerlist";
  },
  cmsSlideBannerMoveUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsslidebannermove";
  },
  cmsSlideBannerStatusUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsslidebannerstatusupdate";
  },
  cmsSlideBannerUpDownUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsslidebannerupdown";
  },

  cmsNewsAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsnewsadd";
  },
  cmsNewsCountUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsnewscount";
  },
  cmsNewsDeleteUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsnewsdelete";
  },
  cmsNewsDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsnewsdetail";
  },
  cmsNewsEditUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsnewsedit";
  },
  cmsNewsListUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsnewslist";
  },
  cmsNewsMoveUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsnewsmove";
  },
  cmsNewsStatusUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsnewsstatusupdate";
  },
  cmsNewsUpDownUrl() {
    return this.baseUrl + this.userBaseUrl + "/cmsnewsupdown";
  },

  withdrawalGSPaySolutionUrl() {
    return this.baseUrl + this.userBaseUrl + "/withdrawalgspaysolution";
  },
  withdrawalPEPayUrl() {
    return this.baseUrl + this.userBaseUrl + "/withdrawalpepay";
  },
  withdrawalUPayUrl() {
    return this.baseUrl + this.userBaseUrl + "/withdrawalupay";
  },
  pgProviderGetBalanceUrl() {
    return this.baseUrl + this.userBaseUrl + "/pgprovidergetbalance";
  },
  ticketApproveWithdrawalGatewayUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketapprovewithdrawalgateway";
  },
  ticketResubmitWithdrawalUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketresubmitwithdrawal";
  },
  ticketRejectAutoWithdrawalUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketrejectautowithdrawal";
  },
  ticketListAutoWithdrawalUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketlistautowithdrawal";
  },
  memberGatewayUserCodeGetUrl() {
    return this.baseUrl + this.userBaseUrl + "/membergatewayusercodeget";
  },
};
